import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {CommonService} from '../../../shared/services/common.service';
import {FetchHeightChartDataModel} from '../models/fetch-height-chart-data.model';
import {FetchHeightChartTableDataModel} from '../models/fetch-height-chart-table-data.model';
import {FetchWeightChartDataModel} from '../models/fetch-weight-chart-data.model';
import {FetchWeightChartTableDataModel} from '../models/fetch-weight-chart-table-data.model';
import {FetchDailyFoodChartDataModel} from '../models/fetch-daily-food-chart-data.model';
import {FetchWeeklyFoodChartDataModel} from '../models/fetch-weekly-food-chart-data.model';
import {FetchWeeklyFoodChartTableDataModel} from '../models/fetch-weekly-food-chart-table-data.model';
import {v1URL} from '../../../shared/constants/urls.constants';
import {FetchBmiChartDataModel} from '../models/fetch-bmi-chart-data.model';
import {FetchBmiChartTableDataModel} from '../models/fetch-bmi-chart-table-data.model';
import {FetchBmiGoalFilterModel} from '../models/fetch-bmi-goal-filter.model';
import {FetchAdultBmiGoalFilterModel} from '../models/fetch-adult-bmi-goal-filter.model';
import {
  FetchDailyPAChartDataModel
} from "../models/fetch-daily-pa-chart-data.model";
import {FetchWeeklyPADataModel} from "../models/fetch-weekly-pa-data.model";
import {FetchJournalChartDataModel} from '../models/fetch-journal-chart-data.model';
import {FetchJournalChartTableDataModel} from '../models/fetch-journal-chart-table-data.model';

@Injectable({
  providedIn: 'root'
})
export class ProgressService {

  constructor(
    private commonService: CommonService,
  ) {
  }

  fetchHeightChartData(payload: FetchHeightChartDataModel['request']): Observable<FetchHeightChartDataModel['response']> {
    const urlConfig = v1URL.progress.fetchHeightChartData
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchHeightChartTableData(payload: FetchHeightChartTableDataModel['request']): Observable<FetchHeightChartTableDataModel['response']> {
    const urlConfig = v1URL.progress.fetchHeightChartTableData
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchWeightChartData(payload: FetchWeightChartDataModel['request']): Observable<FetchWeightChartDataModel['response']> {
    const urlConfig = v1URL.progress.fetchWeightChartData
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchWeightChartTableData(payload: FetchWeightChartTableDataModel['request']): Observable<FetchWeightChartTableDataModel['response']> {
    const urlConfig = v1URL.progress.fetchWeightChartTableData
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchDailyFoodChartData(payload: FetchDailyFoodChartDataModel['request']): Observable<FetchDailyFoodChartDataModel['response']> {
    const urlConfig = v1URL.progress.fetchRedLightFoodChartData
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchWeeklyFoodChartData(payload: FetchWeeklyFoodChartDataModel['request']): Observable<FetchWeeklyFoodChartDataModel['response']> {
    const urlConfig = v1URL.progress.fetchRedLightFoodChartData
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchWeeklyFoodChartTableData(payload: FetchWeeklyFoodChartTableDataModel['request']): Observable<FetchWeeklyFoodChartTableDataModel['response']> {
    const urlConfig = v1URL.progress.fetchRedLightFoodChartTableData
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchBmiChartData(payload: FetchBmiChartDataModel['request']): Observable<FetchBmiChartDataModel['response']> {
    const urlConfig = v1URL.progress.fetchBmiChartData
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchBmiChartTableData(payload: FetchBmiChartTableDataModel['request']): Observable<FetchBmiChartTableDataModel['response']> {
    const urlConfig = v1URL.progress.fetchBmiChartTableData
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchBmiDefaultPercentile(payload: { userId?: number, groupId?: number }): Observable<any> {
    const urlConfig = v1URL.progress.fetchBmiDefaultPercentile
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchBmiGoalFilterData(): Observable<FetchBmiGoalFilterModel['response']> {
    const urlConfig = v1URL.progress.filters.bmiGoal
    return this.commonService.callAPI(urlConfig.method, urlConfig.url());
  }

  fetchAdultBmiGoalFilterData(): Observable<FetchAdultBmiGoalFilterModel['response']> {
    const urlConfig = v1URL.progress.filters.adultBmiGoal
    return this.commonService.callAPI(urlConfig.method, urlConfig.url());
  }

  fetchDailyPhysicalActivityData(payload: FetchDailyPAChartDataModel['request']): Observable<FetchDailyPAChartDataModel['response']> {
    const urlConfig = v1URL.progress.fetchPAChartData
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchWeeklyPhysicalActivityData(payload: FetchWeeklyPADataModel['request']): Observable<FetchWeeklyPADataModel['response']> {
    const urlConfig = v1URL.progress.fetchPAChartData
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchPhysicalActivityTableData(payload: FetchWeeklyFoodChartTableDataModel['request']): Observable<FetchWeeklyPADataModel['response']> {
    const urlConfig = v1URL.progress.fetchPATableData
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchDailySTData(payload: FetchDailyPAChartDataModel['request']): Observable<FetchDailyPAChartDataModel['response']> {
    const urlConfig = v1URL.progress.fetchSTChartData
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchWeeklySTData(payload: FetchWeeklyPADataModel['request']): Observable<FetchWeeklyPADataModel['response']> {
    const urlConfig = v1URL.progress.fetchSTChartData
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchSTTableData(payload: FetchWeeklyFoodChartTableDataModel['request']): Observable<FetchWeeklyPADataModel['response']> {
    const urlConfig = v1URL.progress.fetchSTTableData
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchJournalChartData(payload: FetchJournalChartDataModel['request']): Observable<FetchJournalChartDataModel['response']> {
    const urlConfig = v1URL.progress.fetchJournalChartData
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchJournalChartTableData(payload: FetchJournalChartTableDataModel['request']): Observable<FetchJournalChartTableDataModel['response']> {
    const urlConfig = v1URL.progress.fetchJournalChartTableData
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload));
  }
}
